import { ComplianceStepType } from '@ping/api';

export const FORM_B_STEPS = new Set<ComplianceStepType>([
  ComplianceStepType.PrimaryUse,
  ComplianceStepType.PrimarySource,
  ComplianceStepType.EmploymentStatus,
  ComplianceStepType.TotalValue,
  ComplianceStepType.Industry,
]);
